import styled from "@emotion/styled";
import { isString } from "lodash";
import * as React from "react";
import { Link } from "react-router-dom";

import { LinkEllipsisContainer } from "./Link";

const Value = styled.span<{ hasSpaces?: boolean; monospace?: boolean }>`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.hasSpaces && "word-break: break-word"
  };
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.monospace && "font-family: monospace; letter-spacing: 1px;"
  }
  overflow: hidden;
`;

const EmptyValue = styled(Value)`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor50
  };
`;

const StyledLabelValue = styled.span`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor60
  };
`;

const StyledLink = styled(Link)`
  cursor: pointer;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.linkColor
  };
  text-decoration: none;
`;

const StyledLabel = styled.span<{ inline: boolean }>`
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => !props.inline && "display: block"
  };
`;

interface ILabelWithLinkProps {
  label?: React.ReactNode | string;
  value?: React.ReactNode | string;
  href?: string;
  inline?: boolean;
  height?: string;
  title?: string;
  monospace?: boolean;
  placeholder?: string;
  onLinkClick?(): void;
}

export class LabelWithLink extends React.PureComponent<ILabelWithLinkProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private renderLink = () => (
    <StyledLink
      to={this.props.href || (this.props.value as string)}
      rel="noopener noreferrer"
      onClick={this.props.onLinkClick}
    >
      {this.props.value}
    </StyledLink>
  );

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { placeholder, value, monospace } = this.props;
    const valueProps = { hasSpaces: true, monospace };

    if (isString(value)) {
      valueProps.hasSpaces = /\s/.test(value as string);
    }

    return (
      <div css={LinkEllipsisContainer}>
        <StyledLabelValue>
          {this.props.label && (
            // @ts-expect-error TS(2322)
            <StyledLabel inline={this.props.inline}>
              {this.props.label}
              &nbsp;
            </StyledLabel>
          )}
          {value && <Value {...valueProps}>{this.renderLink()}</Value>}
          {!value && <EmptyValue>{placeholder}</EmptyValue>}
        </StyledLabelValue>
      </div>
    );
  }
}
